// extracted by mini-css-extract-plugin
export default {"field":"Select_field__ONl0A","isBig":"Select_isBig__aL90X","react-select-2-listbox":"Select_react-select-2-listbox__RIV7e"};